import mapper from '../mapper/index.js';
function getPropertyList(arr, state) {
    if (arr && arr.length) {
        return arr.map(function (e) {
            return mapper.property(e, state);
        });
    }
    return [];
}
function updateSearchState(state, { data, glb }) {
    state.cities = data.cities || [];
    state.counties = data.counties || [];
    state.seo = data.seo || null;
    state.nearbyHomes = data.nearbyHomes && data.nearbyHomes.length ? getPropertyList(data.nearbyHomes, glb) : [];
}

export default {
    updateSearchState,
};
